function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Transport({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.172 3a4.35 4.35 0 014.325 3.718l.314 2.066 1.758-.86a1 1 0 11.88 1.796l-1.115.546a4.036 4.036 0 011.674 3.273v6.377c0 1.1-.894 1.997-1.994 2l-3.369.033h-.019c-.489 0-.949-.188-1.296-.533a1.83 1.83 0 01-.547-1.311v-.866l-7.652-.034v.867a1.846 1.846 0 01-1.843 1.844H3c-1.103 0-2-.898-2-2v-6.377c0-1.346.662-2.54 1.677-3.274L1.56 9.72a1 1 0 01.88-1.797l1.72.842.312-2.047A4.352 4.352 0 018.799 3h6.373zm3.8 8.5H5.037A2.04 2.04 0 003 13.54v6.377h3.131v-1.461c0-.691.563-1.253 1.254-1.253l9.151.04c.685 0 1.247.562 1.247 1.252v1.453l3.227-.031-.002-6.377a2.04 2.04 0 00-2.037-2.038zM7.945 13.36a1 1 0 110 2h-2a1 1 0 110-2h2zm10.117 0a1 1 0 110 2h-2a1 1 0 110-2h2zm-2.891-8.477H8.799a2.479 2.479 0 00-2.464 2.119L5.955 9.5h12.06l-.38-2.498a2.479 2.479 0 00-2.463-2.12z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

const MemoTransport = React.memo(Transport);
export default MemoTransport;